module.exports = __webpack_public_path__ + "img/fries.9e6015b2.svg";